import { render } from "./InspectionCall.vue?vue&type=template&id=72e6e982"
import script from "./InspectionCall.vue?vue&type=script&lang=js"
export * from "./InspectionCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__